import styled from 'styled-components';

export const Content = styled.div`
  padding: 0;
  display: flex;
  align-items: center;
`;

export const Badge = styled.span`
  width: 8px;
  height: 8px;

  background: var(--primary-green);
  border-radius: 4px;
  position: absolute;
  left: 0px;
  bottom: 0px;
`;
